import { DndContext, PointerSensor, rectIntersection, useSensor, useSensors, type DragEndEvent } from "@dnd-kit/core";
import { useCustomArtStore } from "../../../stores/custom-art-store";
import { dispatchScheduleEvent } from "../../../lib/schedule-history/dispatch";
import { ArtLayerRow } from "./ArtLayerRow";

export function ArtLayerList() {
  const layers = useCustomArtStore(state => state.layers);
  const pointer = useSensor(PointerSensor, { activationConstraint: { distance: 4 } });
  const sensors = useSensors(pointer);
  const rows = [...layers].reverse();

  const reorder = ({ active, over }: DragEndEvent) => {
    if (!over || active.id === over.id) return;
    const ids = rows.map(layer => layer.imageId);
    const from = ids.indexOf(String(active.id));
    const to = ids.indexOf(String(over.id));
    if (from < 0 || to < 0) return;
    const reordered = ids.filter(id => id !== active.id);
    reordered.splice(to, 0, String(active.id));
    dispatchScheduleEvent({ type: "art/reorder", imageIds: reordered.reverse() });
  };

  return (
    <DndContext sensors={sensors} collisionDetection={rectIntersection}
      onDragStart={({ active }) => useCustomArtStore.getState().selectLayer(String(active.id))} onDragEnd={reorder}>
      <div className="max-h-[450px] space-y-1.5 overflow-y-auto">{rows.map(layer => <ArtLayerRow key={layer.imageId} layer={layer} />)}</div>
    </DndContext>
  );
}
